class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.announcementBar = this.querySelector("#wt-announcement__container");
    this.announcementInterval = null;

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.isMobileView = this.isMobileView.bind(this);
    this.isDesktopCenterSlider = this.isDesktopCenterSlider.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (
      !this.announcementBar?.classList.contains(
        "wt-announcement__container--marquee"
      )
    ) {
      this.announcementInterval = setInterval(this.changeAnnouncement, 5000);

      if (this.announcementBar) {
        this.announcementBar.addEventListener(
          "touchstart",
          this.handleTouchStart,
          { passive: true }
        );

        this.announcementBar.addEventListener(
          "touchmove",
          this.handleTouchMove,
          { passive: true }
        );

        this.announcementBar.addEventListener(
          "touchend",
          this.handleTouchEnd,
          { passive: true }
        );

        this.announcementBar.addEventListener(
          "touchstart",
          () => clearInterval(this.announcementInterval),
          { passive: true }
        );

        this.announcementBar.addEventListener(
          "touchend",
          this.restartInterval,
          { passive: true }
        );
      }
    }

    if (this.announcementBar) {
      this.announcementBar.style.transition = "transform 0.5s ease-in-out";
    }

    this.closeButton = this.querySelector(".wt-announcement__close");

    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.hideForOneDay);
    }

    window.addEventListener("resize", this.handleResize);
  }

  isMobileView() {
    return window.innerWidth < 900;
  }

  isDesktopCenterSlider() {
    return this.announcementBar?.classList.contains(
      "wt-announcement__container--desktop-center-slider"
    );
  }

  shouldSlide() {
    return this.isMobileView() || this.isDesktopCenterSlider();
  }

  getTranslateUnit() {
  if (this.isMobileView()) {
    return "vw";
  }

  return this.isDesktopCenterSlider() ? "%" : "vw";
} 

  handleResize() {
    if (this.announcementBar) {
      this.announcementBar.style.transform = "translateX(0)";
      this.currentIndex = 0;
    }
  }

  restartInterval() {
    clearInterval(this.announcementInterval);
    this.announcementInterval = setInterval(this.changeAnnouncement, 5000);
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }

  changeAnnouncement() {
    if (!this.shouldSlide()) return;

    const totalSlides = this.announcementBar?.children.length || 0;
    if (!totalSlides) return;

    this.currentIndex = (this.currentIndex + 1) % totalSlides;

    const newPosition = -(this.currentIndex * 100);
    const unit = this.getTranslateUnit();

    if (this.announcementBar) {
      this.announcementBar.style.transform = `translateX(${newPosition}${unit})`;
    }

    if (this.currentIndex === 0 && this.announcementBar) {
      setTimeout(() => {
        this.announcementBar.style.transition = "none";
        this.announcementBar.style.transform = "translateX(0)";
        this.currentIndex = 0;

        setTimeout(() => {
          this.announcementBar.style.transition =
            "transform 0.5s ease-in-out";
        }, 0);
      }, 490);
    }
  }

  previousAnnouncement() {
    if (!this.shouldSlide()) return;

    const totalSlides = this.announcementBar?.children.length || 0;
    if (!totalSlides) return;

    this.currentIndex = (this.currentIndex - 1 + totalSlides) % totalSlides;

    const newPosition = -(this.currentIndex * 100);
    const unit = this.getTranslateUnit();

    if (this.announcementBar) {
      this.announcementBar.style.transform = `translateX(${newPosition}${unit})`;
    }
  }

  handleTouchStart(e) {
    if (this.isMobileView()) {
      this.touchStartX = e.touches[0].clientX;
    }
  }

  handleTouchMove(e) {
    if (this.isMobileView()) {
      this.touchEndX = e.touches[0].clientX;
    }
  }

  handleTouchEnd() {
    if (!this.isMobileView()) return;

    const swipeThreshold = 30;

    if (Math.abs(this.touchEndX - this.touchStartX) > swipeThreshold) {
      if (this.touchEndX < this.touchStartX) {
        this.changeAnnouncement();
      } else {
        this.previousAnnouncement();
      }
    }
  }

  disconnectedCallback() {
    clearInterval(this.announcementInterval);

    if (this.announcementBar) {
      this.announcementBar.removeEventListener(
        "touchstart",
        this.handleTouchStart
      );
      this.announcementBar.removeEventListener(
        "touchmove",
        this.handleTouchMove
      );
      this.announcementBar.removeEventListener(
        "touchend",
        this.handleTouchEnd
      );
    }

    window.removeEventListener("resize", this.handleResize);
  }
}

customElements.define("announcement-bar", AnnouncementBar);